export const UI_NAV_LABELS = {
  dashboard: 'Tableau de bord',
  deliveries: 'Mes livraisons',
  deliveriesAdmin: 'Livraisons',
  newDelivery: 'Nouvelle livraison',
  tracking: 'Suivi de colis',
  history: 'Historique',
  wallet: 'Portefeuille',
  walletSeller: 'Portefeuille vendeur',
  integrations: 'Int\u00e9grations',
  importedOrders: 'Commandes importees',
  trustReviews: 'Confiance & avis',
  notificationPreferences: 'Pr\u00e9f\u00e9rences notifications',
  savedAddresses: 'Adresses enregistr\u00e9es',
  affiliate: 'Affiliation',
  missions: 'Mes missions',
  vendors: 'Vendeurs',
  validations: 'Validations',
  couriers: 'Livreurs',
  relayAgents: 'Agents P-R',
  relayPoints: 'Points relais',
  deliverySla: 'Délais de livraison',
  administrators: 'Administrateurs',
  validatedDeliveries: 'Livraisons valid\u00e9es',
  proDashboard: 'Tableau de bord Pro',
  paymentValidations: 'Validations paiements',
  proSubscriptions: 'Abonnements Pro',
  vendorWallets: 'Portefeuilles vendeurs',
  inactiveUsers: 'Utilisateurs inactifs',
  vendorKyc: 'KYC vendeurs',
  reportsExports: 'Rapports & Exports',
  courierStatistics: 'Statistiques livreurs',
  gpsLiveTracking: 'Suivi GPS Live',
  blogCms: 'Blog',
  settings: 'Param\u00e8tres',
  about: '\u00c0 propos',
  auditLogs: 'Journaux d\'audit',
  apiConfig: 'Configuration API',
  multiCountry: 'Gestion multi-pays',
  promoCodes: 'Codes promo',
  affiliateProgram: 'Affilies vendeurs',
  ambassadorApplications: 'Ambassadeurs',
  superAmbassadors: 'Super ambassadeurs',
  promoBanners: 'Banni\u00e8res promo',
  crmNewsletter: 'CRM / Newsletter',
  securityFraudMonitoring: 'Security & Fraud',
};

export const UI_AUTH_LABELS = {
  loginTab: 'Connexion',
  registerTab: 'Inscription',
  loginAction: 'Se connecter',
  registerAction: 'Cr\u00e9er un compte',
};

export const UI_ACTION_LABELS = {
  back: 'Retour',
  cancel: 'Annuler',
  close: 'Fermer',
  confirm: 'Confirmer',
  login: 'Se connecter',
  logout: 'D\u00e9connexion',
  payNow: 'Payer maintenant',
  updateStatus: 'Mettre \u00e0 jour le statut',
  openMenu: 'Ouvrir le menu',
  collapseMenu: 'R\u00e9duire le menu',
  seeAccounts: 'Voir les comptes',
  validate: 'Valider',
};

export const UI_ROLE_LABELS = {
  seller: 'Vendeur',
  admin: 'Administrateur',
  courier: 'Livreur',
};

export const UI_STATUS_LABELS = {
  verified: 'V\u00e9rifi\u00e9',
  pending: 'En attente',
  paid: 'Pay\u00e9',
  delivered: 'Livr\u00e9',
  paymentConfirmed: 'Paiement confirm\u00e9',
};

export const UI_FEEDBACK_MESSAGES = {
  seeYouSoon: '\u00c0 bient\u00f4t !',
  accountPendingValidation: 'Votre compte est en attente de validation',
  pendingAccountBanner: 'Compte en attente de validation',
  rechargePendingValidation: 'Recharge en cours de validation',
  rechargeSuccess: 'Recharge effectu\u00e9e avec succ\u00e8s',
  rechargeRedirect: 'Redirection vers le paiement s\u00e9curis\u00e9...',
  rechargeProcessing: 'Traitement de la recharge...',
  noPaymentMethod: 'Aucune m\u00e9thode de paiement disponible',
  validationCancelled: 'Validation annul\u00e9e',
  userValidated: 'Utilisateur valid\u00e9',
  statusUpdatedSuccess: 'Statut mis \u00e0 jour avec succ\u00e8s',
  paymentVerificationInProgress: 'V\u00e9rification du paiement en cours...',
  paymentVerificationUnavailable: 'V\u00e9rification de paiement indisponible.',
  paymentSessionMissing: 'Session de paiement manquante dans l\'URL.',
  paymentCouldNotBeConfirmed: 'Le paiement n\'a pas encore pu \u00eatre confirm\u00e9.',
  paymentConfirmationFailed: 'Impossible de confirmer automatiquement cette session.',
  thanksForPayment: 'Merci pour votre paiement.',
  subscriptionActivated: 'Abonnement activ\u00e9.',
  commandAwaitingAssignment: 'Commande en attente d\'attribution.',
  notificationPreferencesSaved: 'Pr\u00e9f\u00e9rences notifications enregistr\u00e9es.',
  savedAddressSaved: 'Adresse enregistr\u00e9e.',
  savedAddressDeleted: 'Adresse supprim\u00e9e.',
  savedAddressDefaultUpdated: 'Adresse par d\u00e9faut mise \u00e0 jour.',
};

export const UI_PAGE_TITLES = {
  administration: 'Administration',
  integrationsEcommerce: 'Int\u00e9grations e-commerce',
  deliveryDetail: 'D\u00e9tail de livraison',
  subscriptionSeller: 'Abonnement vendeur',
  accountSettings: 'Param\u00e8tres du compte',
  notificationPreferences: 'Pr\u00e9f\u00e9rences notifications',
  savedAddresses: 'Adresses enregistr\u00e9es',
};
